import { Box, Grid, pn, Stack, useElementBreakpoints } from "@compass/core";
import { CustomFilters, Select } from "components";
import { LkStudentEnrollmentDisplayFieldId, StudentEnrollmentFilter as StudentEnrollmentFilterModel, StudentEnrollmentFilterResource, StudentEnrollmentListResource, StudentEnrollmentViewResource } from "generated/openApi";
import produce from "immer";
import { useEffect, useState } from "react";
import ApiService from "services/apiService";

export const StudentEnrollmentFilter = (props: {
  resource?: StudentEnrollmentListResource | null;
  filter: StudentEnrollmentFilterModel;
  setFilter: (filter: StudentEnrollmentFilterModel) => void;
}) => {
  const displayFields = props.resource?.displayFields || [];
  const [resource, setResource] = useState<StudentEnrollmentFilterResource>({});
  const properties = resource.properties || [];
  const { breakpointsRef, largeFieldBreakpoints } = useElementBreakpoints();

  const schoolDisplayField = displayFields.find((x) => x.id === LkStudentEnrollmentDisplayFieldId.School);

  useEffect(() => {
    ApiService.studentEnrollments.getFilterResource().then((response) => {
      setResource(response);
    });
  }, []);

  const schoolYearsField = () => {
    const propertyName = pn<StudentEnrollmentFilterModel>("schoolYears");
    const property = properties.find((x) => x.propertyName === propertyName);

    return (
      <Select
        modelProperty={property}
        multiple
        value={resource.schoolYears?.filter((x) => props.filter.schoolYears?.includes(x.id))}
        options={resource.schoolYears}
        getOptionLabel={option => option.name}
        onChange={(e, values) =>
          props.setFilter(
            produce(props.filter, (draft) => {
              draft.schoolYears = values.map((x) => x.id);
            })
          )
        }
      />
    );
  };

  const schoolsField = () => {
    const propertyName = pn<StudentEnrollmentFilterModel>("schoolIds");
    const property = properties.find((x) => x.propertyName === propertyName);

    return (
      <Select
        modelProperty={property}
        multiple
        value={resource.schools?.filter((x) => props.filter.schoolIds?.includes(x.id))}
        options={resource.schools}
        getOptionLabel={option => option.name}
        onChange={(e, values) =>
          props.setFilter(
            produce(props.filter, (draft) => {
              draft.schoolIds = values.map((x) => x.id);
            })
          )
        }
      />
    );
  };

  return (
    <Stack ref={breakpointsRef} spacing="lg">
      <CustomFilters
        filters={props.filter.customFilters}
        setFilters={(filters) =>
          props.setFilter(
            produce(props.filter, (draft) => {
              draft.customFilters = filters;
            })
          )
        }
        properties={resource.customFilterProperties}
      />

      <Box>
        <Grid ref={breakpointsRef} container spacing="sm">
          <Grid item xs={largeFieldBreakpoints}>
            {schoolYearsField()}
          </Grid>

          <Grid item xs={largeFieldBreakpoints}>
            {schoolsField()}
          </Grid>
        </Grid>
      </Box>
    </Stack>
  );
};
